import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import combosData from "../data/combos-and-packs.json";
import Productlistcard from "../components/Productlistcard";
import { Helmet } from "react-helmet";
import ProductDetailedCard from "../components/ProductDetailedCard";
import FaqPage from "./FaqPage";

const ComboDetailPage = () => {
  const { str } = useParams(); // updated param name
  const [combo, setCombo] = useState(null);
  const [imageKeys, setImageKeys] = useState([]);

  useEffect(() => {
    const foundCombo = combosData.combos.find(
      (item) => item.str.toLowerCase() === str.toLowerCase()
    );
    setCombo(foundCombo);

    if (foundCombo) {
      const keys = [
        "image",
        "image1",
        "image2",
        "image3",
        "image4",
        "image5",
        "image6",
        "image7"
      ].filter((key) => foundCombo[key]);

      setImageKeys(keys);
    }
  }, [str]);

  const images = imageKeys.map((key) => ({
    src: `/${combo[key]}`,
    thumb: `/${combo[key]}`,
    alt: combo?.name || combo?.title,
  }));

  if (!combo) {
    return (
      <div className="text-red-600 text-center py-16 font-semibold text-lg">
        Combo not found.
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <link rel="preload" as="image" href={`/${combo.image}`} />
      </Helmet>

      <section className="py-2 lg:py-4 text-black">
        <div className="container mx-auto">
          <ProductDetailedCard product={combo} images={images} />
          <div>
            {[1, 2, 3, 4, 5].map((n) => {
              const key = `coverimage${n}`;
              return (
                combo[key] && (
                  <img
                    key={key}
                    alt={combo.name || combo.title}
                    className="w-full h-auto object-cover object-center mt-10 border-2"
                    src={`/${combo[key]}`}
                  />
                )
              );
            })}
          </div>

          <section className="text-black">
            <div className="container mt-10">
              <h2 className="text-2xl md:text-4xl text-center font-bold">Our Other Products</h2>
              <Productlistcard />
            </div>
          </section>

          <FaqPage />
        </div>
      </section>
    </>
  );
};

export default ComboDetailPage;
